<template>
  <Layout>
    <router-view></router-view>
  </Layout>
</template>

<script>
import Layout from "@/layouts/main.vue";
import LocalStorageHelper from "@/helpers/localStorageHelper";
import { decodeJwtTokenPayload } from "@/helpers/jwtHelper";
import { mapGetters } from "vuex";

export default {
  name: "App",

  components: {
    Layout,
  },

  created() {
    // Token varsa token refresh timer'ını başlat (route'tan bağımsız)
    const token = localStorage.getItem("token");
    if (token) {
      this.$store.dispatch("tokenRefresh/start");
    }
  },

  computed: {
    ...mapGetters("sessionTimer", {
      showWarning: "showWarning",
      warningDuration: "warningDuration",
    }),
  },

  watch: {
    showWarning(newVal) {
      if (newVal) {
        this.showSessionWarning();
      }
    },
  },

  methods: {
    showSessionWarning() {
      this.$swal.fire({
        title: this.$t("SessionWarningTitle"),
        html:
          this.$t("SessionWarningMessage") + '<br/><br/>' +
          '<button id="stop" class="btn btn-success">' +
          this.$t("SessionExtendButton") +
          "</button><br/><br/>" +
          '<button id="resume" class="btn btn-danger">' +
          this.$t("SessionLogoutButton") +
          "</button><br/><br/>",
        timer: this.warningDuration,
        didOpen: () => {
          const content = this.$swal.getHtmlContainer();
          const $ = content.querySelector.bind(content);

          const stop = $("#stop");
          const resume = $("#resume");
          const timerText = $("#timerText");

          this.$swal.showLoading();

          stop.addEventListener("click", () => {
            this.$store.dispatch("sessionTimer/dismissWarning");
            this.$swal.close();
          });

          resume.addEventListener("click", () => {
            this.performLogout();
          });

          setInterval(() => {
            timerText.textContent = (
              this.$swal.getTimerLeft() / 1000
            ).toFixed(0);
          }, 100);
        },
        willClose: () => {
          if (this.$store.state.sessionTimer.showWarning) {
            this.performLogout();
          }
        },
      });
    },

    performLogout() {
      // willClose ile döngüsel çağrıyı önle
      this.$store.commit("sessionTimer/SET_WARNING", false);
      this.$swal.close();

      // Logout öncesi AuthType'ı belirle (token silinmeden önce)
      let authType = null;
      const token = localStorage.getItem("token");
      if (token) {
        try {
          authType = decodeJwtTokenPayload(token).AuthType || null;
        } catch {
          authType = null;
        }
      }
      authType = authType || localStorage.getItem("lastAuthType");

      this.$store.dispatch("sessionTimer/stop");
      this.$store.dispatch("tokenRefresh/stop");
      LocalStorageHelper.clearAllForLogout();

      const backendBaseUrl = process.env.VUE_APP_BACKEND_URL;

      if (authType === "OTP") {
        this.$router.push({ name: "GuestLogin" });
      } else if (authType === "SAML") {
        window.location.replace(
          `${backendBaseUrl}/api/Identity/Auth/Logout`
        );
      } else {
        this.$router.push({ name: "LoginLanding" });
      }
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
